import React from 'react';
import { AuthProvider } from '@/contexts/AuthContext';
import { EntraAuthProvider } from '@/contexts/EntraAuthContext';
import QueryProvider from '@/contexts/QueryProvider';
import AppRouter from '@/router';
import { useKonamiCode } from '@/hooks/useKonamiCode';

import { env } from '@/lib/env';

// Determine which auth provider to use based on environment
const AUTH_MODE = env.AUTH_MODE;

// Inner component that uses the Konami code hook
function AppContent() {
  // 🕹️ Easter egg: Konami code activates retro 80s theme
  useKonamiCode();

  return <AppRouter />;
}

function App() {
  // Choose auth provider based on mode
  const AuthProviderComponent = AUTH_MODE === 'entra' ? EntraAuthProvider : AuthProvider;

  return (
    <QueryProvider>
      <AuthProviderComponent>
        <AppContent />
      </AuthProviderComponent>
    </QueryProvider>
  );
}

export default App;